import './styles/step2-placeholder.scss'

const mock = new Array(4).fill(null)

export default function PlaceholderCheckoutStep2() {
  return mock.map((_, index) => (
    <div key={index} className='checkout-placeholder'>
      <section className='inclusions-section placeholder-animation'>
        <div className='checkout-placeholder__title'>
          <div className='icon' />
        </div>
        <div className='checkout-placeholder__table-title' />
        <div className='checkout-placeholder__table'>
          <div className='t-row'>
            <div className='t-cell' />
          </div>
          <div className='t-row'>
            <div className='t-cell' />
          </div>
          <div className='t-row'>
            <div className='t-cell' />
          </div>
        </div>
      </section>
    </div>
  ))
}
